import { InputAdornment, TextField } from '@mui/material';
import { Controller, useFormContext } from 'react-hook-form';

interface MuiInputColorControlledProps {
  inputColorProps: {
    name: string;
    defaultValue?: string;
    label?: string;
    placeholder?: string;
  };
  styles?: any;
}

export function MuiInputColorControlled({
  inputColorProps,
  styles = {},
}: MuiInputColorControlledProps) {
  const {
    control,
    watch,
    formState: { errors },
  } = useFormContext();

  const color = watch(inputColorProps.name);

  return (
    <Controller
      control={control}
      name={inputColorProps.name}
      defaultValue={inputColorProps.defaultValue ?? ''}
      render={({ field }) => (
        <TextField
          id={inputColorProps.name}
          label={inputColorProps.label ?? ''}
          helperText={
            errors[inputColorProps.name]
              ? String(errors[inputColorProps.name]?.message)
              : ''
          }
          variant="outlined"
          placeholder={inputColorProps.placeholder ?? ''}
          error={!!errors[inputColorProps.name]}
          {...field}
          {...inputColorProps}
          sx={styles}
          fullWidth
          InputProps={{
            startAdornment: (
              <InputAdornment position="end">
                <div
                  style={{
                    width: '20px',
                    height: '20px',
                    backgroundColor: color === '' ? '#fff' : color,
                    border: '1px solid #ccc',
                    borderRadius: '3px',
                    marginRight: '8px',
                  }}
                />
              </InputAdornment>
            ),
          }}
        />
      )}
    />
  );
}
